import { render, staticRenderFns } from "./CaosUserSyncMainTable.vue?vue&type=template&id=08daf974&scoped=true&"
import script from "./CaosUserSyncMainTable.vue?vue&type=script&lang=ts&"
export * from "./CaosUserSyncMainTable.vue?vue&type=script&lang=ts&"
import style0 from "./CaosUserSyncMainTable.vue?vue&type=style&index=0&id=08daf974&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08daf974",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VChipGroup,VCol,VDataTable,VDivider,VRow,VSpacer,VToolbar,VToolbarItems,VToolbarTitle,VTooltip})
